import api from '../../../services/api';

export const WhoIsInHTTP = {
  get: (params = {}) => api.get('/who-is-in', {params}),
};
